import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ViewerLoading from './ViewerLoading';

/**
 * Renders a PDF in the browser's built-in viewer.
 *
 * The signed URL is minted with an inline content type, so pointing an
 * iframe at it is enough - no PDF.js dependency, and page navigation,
 * search and zoom come from the browser for free. This works without a
 * bucket CORS policy because an iframe src is a plain navigation.
 */
const PdfViewer = ({ url, title, reloadNonce = 0 }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [url, reloadNonce]);

  return (
    <Box sx={{ position: 'absolute', inset: 0 }}>
      {loading && <ViewerLoading label={`Loading ${title || 'document'}\u2026`} />}
      <iframe
        key={`${url}#${reloadNonce}`}
        title={title || 'Document'}
        // Both sidebar flags are needed: Chrome/Edge only implement
        // navpanes, Firefox's pdf.js only implements pagemode. FitH opens at
        // a readable width instead of the browser's last-remembered zoom.
        src={`${url}#navpanes=0&pagemode=none&view=FitH`}
        onLoad={() => setLoading(false)}
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      />
    </Box>
  );
};

export default PdfViewer;
